var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.166 9.9165H10.3327C9.36022 9.9165 8.42759 10.3028 7.73996 10.9904C7.05232 11.6781 6.66602 12.6107 6.66602 13.5832V39.2498C6.66602 40.2223 7.05232 41.1549 7.73996 41.8426C8.42759 42.5302 9.36022 42.9165 10.3327 42.9165H35.9993C36.9718 42.9165 37.9044 42.5302 38.5921 41.8426C39.2797 41.1549 39.666 40.2223 39.666 39.2498V26.4165",
    stroke: "#02B4BA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.916 7.16668C37.6454 6.43733 38.6346 6.02759 39.666 6.02759C40.6975 6.02759 41.6867 6.43733 42.416 7.16668C43.1454 7.89602 43.5551 8.88522 43.5551 9.91667C43.5551 10.9481 43.1454 11.9373 42.416 12.6667L24.9993 30.0833L17.666 31.9167L19.4993 24.5833L36.916 7.16668Z",
    stroke: "#02B4BA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8e9629e15ba3158f0fe17103cdbf0e50.svg";
export { ForwardRef as ReactComponent };